import axios from 'axios';

const baseURL = process.env.REACT_APP_API_BASE_URL;

const apiClient = axios.create({
    baseURL: baseURL,
    withCredentials: true,
});

const refreshClient = axios.create({
    baseURL: baseURL,
    withCredentials: true,
});



apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        console.log('API request error:', error.response);
        console.log('API request status:', error.response.status);

        const originalRequest = error.config;
        console.log('API request retry:', originalRequest._retry);
        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            console.log('try to refresh token');
            originalRequest._retry = true;
            try {
                const response = await refreshClient.post('/auth/refresh-token');
                if (response.status === 200) {
                    return apiClient(originalRequest);
                }
            } catch (refreshError) {
                await refreshClient.post('/auth/custom-logout')
                window.location.href = '/login'
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);


export default apiClient;
